export default {
  email: 'Email',
  profile: 'Perfil',
  linkedUser: 'Usuário vinculado',
  group: 'Grupo',
  groups: 'Grupos',
  lastSeen: 'Visto pela última vez',
  appVersion: 'Versão do aplicativo'
}
